import { useQuery } from "@tanstack/react-query";
import apiFetch from "../../utils/apiFetch";
import { authHeaders } from "./helpers";
import type { ArchivedForm } from "./types";

export function useArchivedForms() {
  return useQuery<ArchivedForm[]>({
    queryKey: ["archived-forms"],
    queryFn: async () => {
      const r = await apiFetch("/api/v1/payroll/taxes/archived-forms", {
        headers: authHeaders(),
      });
      if (!r.ok) throw new Error("HTTP " + r.status);
      const data = await r.json();
      return Array.isArray(data) ? data : [];
    },
    refetchOnWindowFocus: false,
  });
}